import { render, staticRenderFns } from "./DigitalDocFullList.vue?vue&type=template&id=9b96ce44&scoped=true"
import script from "./DigitalDocFullList.vue?vue&type=script&lang=js"
export * from "./DigitalDocFullList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b96ce44",
  null
  
)

export default component.exports